import { DISPATCH_DECISIONS_VIEW_VOCABULARIES } from './dispatch-decisions-view.js';
/** Slice d587 of the catalog (D577): the vocabularies the Admin dispatch decisions panel (D587) brought. */
export const SLICE_D587 = [...DISPATCH_DECISIONS_VIEW_VOCABULARIES];
//# sourceMappingURL=slice-d587.js.map